/**
 * Remplace the hold SVG logo of Twilio for the Octipas logo.
 * Thanks for your work Twilio! <3
 */
import React, { Component } from 'react';

class OctipasLogo extends Component {
  render() {
    return (
      <img
        style={{
          width: '6rem',
          position: 'absolute',
          bottom: '15px',
          right: '15px',
        }}
        src="https://octipas.fr/wp-content/uploads/2020/09/logo-octipas-2020-noir-4.png"
        alt="octipas logo"
      ></img>
    );
  }
}
export default OctipasLogo;
